<template>
  <div class="doc-section">
    <div class="section-header">
      <span class="material-icons-sharp section-icon">low_priority</span>
      <h2>Retour en stock</h2>
    </div>

    <p class="section-intro">
      Le module Retour en stock gère les marchandises retournées par les clients ou transférées
      entre magasins. Deux niveaux de validation existent : la déclaration (par le magasinier)
      et la validation (par l'administrateur).
    </p>

    <!-- ===== DÉCLARATION ===== -->
    <h3 class="sub-title">Déclarer un retour (Magasinier)</h3>
    <div class="table-wrapper">
      <table>
        <thead>
          <tr><th>Champ</th><th>Type</th><th>Obligatoire</th><th>Ce qu'il faut saisir</th></tr>
        </thead>
        <tbody>
          <tr><td><strong>Produit</strong></td><td>Liste déroulante</td><td><span class="required-badge badge-yes">Oui</span></td><td>Le produit retourné.</td></tr>
          <tr><td><strong>Quantité retournée</strong></td><td>Nombre</td><td><span class="required-badge badge-yes">Oui</span></td><td>Quantité effectivement retournée.</td></tr>
          <tr><td><strong>Motif du retour</strong></td><td>Texte</td><td><span class="required-badge badge-yes">Oui</span></td><td>Raison du retour (défaut, erreur de commande, etc.).</td></tr>
          <tr><td><strong>Fichier preuve</strong></td><td>Fichier</td><td><span class="required-badge badge-no">Non</span></td><td>Photo ou document justificatif.</td></tr>
          <tr><td><strong>Observation</strong></td><td>Texte</td><td><span class="required-badge badge-no">Non</span></td><td>Commentaire additionnel.</td></tr>
        </tbody>
      </table>
    </div>

    <h4 class="sub-title">Procédure</h4>
    <div class="steps">
      <div class="step-item">
        <div class="step-num">1</div>
        <p>Ouvrez le module <strong>Retour en stock</strong> depuis le menu latéral.</p>
      </div>
      <div class="step-item">
        <div class="step-num">2</div>
        <p>Cliquez sur <span class="btn-ref">Ajouter</span>.</p>
      </div>
      <div class="step-item">
        <div class="step-num">3</div>
        <p>Sélectionnez le <em>Produit</em>, saisissez la <em>Quantité retournée</em> et le <em>Motif du retour</em>.</p>
      </div>
      <div class="step-item">
        <div class="step-num">4</div>
        <p>Joignez un justificatif si nécessaire.</p>
      </div>
      <div class="step-item">
        <div class="step-num">5</div>
        <p>Cliquez sur <span class="btn-ref">Soumettre</span>. Le retour est enregistré et en attente de validation par l'administrateur.</p>
      </div>
    </div>

    <!-- ===== VALIDATION ADMIN ===== -->
    <h3 class="sub-title">Valider un retour (Administrateur)</h3>
    <p class="section-text">
      L'administrateur voit les retours déclarés et peut les accepter (le stock est incrémenté)
      ou les rejeter.
    </p>
    <div class="table-wrapper">
      <table>
        <thead>
          <tr><th>Information</th><th>Description</th></tr>
        </thead>
        <tbody>
          <tr><td><strong>Produit</strong></td><td>Nom du produit retourné (non modifiable).</td></tr>
          <tr><td><strong>Quantité retournée</strong></td><td>Quantité déclarée (non modifiable).</td></tr>
          <tr><td><strong>Fichier preuve</strong></td><td>Justificatif joint (téléchargeable).</td></tr>
          <tr><td><strong>Observation</strong></td><td>Commentaire du magasinier.</td></tr>
        </tbody>
      </table>
    </div>

    <h4 class="sub-title">Procédure</h4>
    <div class="steps">
      <div class="step-item">
        <div class="step-num">1</div>
        <p>Cliquez sur le retour à traiter dans le tableau.</p>
      </div>
      <div class="step-item">
        <div class="step-num">2</div>
        <p>Examinez les informations et le justificatif.</p>
      </div>
      <div class="step-item">
        <div class="step-num">3</div>
        <p><strong>Pour valider :</strong> Cliquez sur <span class="btn-ref">Accepter le retour en stock</span>. Le stock est incrémenté de la quantité retournée.</p>
      </div>
      <div class="step-item">
        <div class="step-num">4</div>
        <p><strong>Pour refuser :</strong> Cliquez sur <span class="btn-ref">Rejeter le retour en stock</span>. Le retour est annulé.</p>
      </div>
    </div>

    <div class="info-card info">
      <div class="card-title">
        <span class="material-icons-sharp" style="font-size:16px;color:#5b9bd5">info</span>
        Bon à savoir
      </div>
      <p>
        L'acceptation d'un retour incrémente automatiquement le stock du magasin concerné.
        L'historique des retours (acceptés et rejetés) reste consultable dans le tableau.
      </p>
    </div>
  </div>
</template>
<script>
export default { name: "DocRetour" };
</script>
